module.exports = __webpack_public_path__ + "static/media/gallery6.00c03d37.jpg";